

import React, { useState } from "react";

const CardIcon = ({ iconurl, subheading }) => {
  const [errored, setErrored] = useState(false);

  return (
    <div
      style={{
    width: "80px",   // control icon size
    height: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "12px",
  }}
    >
      {iconurl && !errored ? (
        <img
          src={iconurl}
          alt={subheading}
          onError={() => setErrored(true)}
          style={{
            width: "80px",
            height: "80px",
            objectFit: "contain",
          }}
        />
      ) : (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
    </div>
  );
};

const styles = `
  .ts-section {
    background: #ffffff;
    padding: 56px max(60px, calc(50% - 660px));
    font-family: Inter, sans-serif;
  }
  .ts-heading {
    font-size: 40px;
    font-weight: 700;
    line-height: 1.3;
    color: var(--color-brand-primary);
    margin: 0 0 8px 0;
  }
  .ts-heading-accent { color: var(--color-brand-green); }
  .ts-desc {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4;
    color: var(--color-text-subheading);
    margin: 0;
  }
  .ts-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    margin-top: 32px;
  }
  .ts-card {
    background: #ffffff;
    border: 1px solid #DFF1FB;
    border-radius: 12px;
    box-shadow: 0px 0px 15px 0px #80DAF1;
    padding: 16px 24px 28px;
    transition: box-shadow 0.2s, transform 0.2s;
  }
  .ts-card:hover {
    box-shadow: 0px 0px 22px 0px #80DAF1;
    transform: translateY(-2px);
  }
  .ts-icon {
    width: 72px;
    height: 72px;
    object-fit: contain;
    display: block;
    margin-bottom: 20px;
  }
  .ts-card-title {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
    color: var(--color-brand-primary);
    margin: 0 0 16px 0;
  }
  .ts-card-desc {
    font-size: 15px;
    font-weight: 500;
    line-height: 1.45;
    color: var(--color-text-subheading);
    margin: 0;
  }

  @media (max-width: 1279px) and (min-width: 1101px) {
    .ts-section { padding: 48px 40px; }
    .ts-heading { font-size: 36px; }
  }
  @media (max-width: 1100px) and (min-width: 768px) {
    .ts-section { padding: 40px 28px; }
    .ts-heading { font-size: 30px; }
    .ts-desc { font-size: 17px; }
    .ts-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
    .ts-card-title { font-size: 20px; }
  }
  @media (max-width: 767px) {
    .ts-section { padding: 32px 14px; }
    .ts-heading { font-size: 26px; }
    .ts-desc { font-size: 15px; }
    .ts-grid { grid-template-columns: 1fr; gap: 14px; margin-top: 20px; }
    .ts-card { padding: 14px 18px 20px; }
    .ts-icon { width: 56px; height: 56px; margin-bottom: 12px; }
    .ts-card-title { font-size: 18px; margin-bottom: 8px; }
    .ts-card-desc { font-size: 14px; }

    /* mobileRow: icon on the left, vertically centred against the title + description */
    .ts-section--row .ts-card {
      display: grid;
      grid-template-columns: 56px 1fr;
      column-gap: 14px;
      align-items: center;
      padding: 14px 16px;
    }
    .ts-section--row .ts-icon { grid-column: 1; grid-row: 1 / span 2; margin: 0; align-self: center; }
    .ts-section--row .ts-card-title,
    .ts-section--row .ts-card-desc { grid-column: 2; }
    .ts-section--row .ts-card-title { margin-bottom: 4px; align-self: end; }
    .ts-section--row .ts-card-desc { align-self: start; }
  }
`;

// mobileRow (opt-in): on phones, show each card as a row with the icon on the left
const ThirdSection = ({ data = {}, mobileRow = false }) => {
  const thirdsub = data?.thirdsub || [];

  // "Why CureBay LungsCare" → last word (the product name) in green
  const headingWords  = (data.heading || "").trim().split(" ");
  const headingAccent = headingWords.length > 1 ? headingWords.pop() : "";
  const headingMain   = headingWords.join(" ");

  return (
    <>
      <style>{styles}</style>
      <section className={`ts-section${mobileRow ? " ts-section--row" : ""}`}>
        {/* 🔹 Main heading — left-aligned */}
        <h2 className="ts-heading">
          {headingMain}{headingAccent && " "}
          {headingAccent && <span className="ts-heading-accent">{headingAccent}</span>}
        </h2>

        {/* 🔹 Description — left-aligned */}
        {data.description && <p className="ts-desc">{data.description}</p>}

        {/* 🔹 Feature Cards */}
        <div className="ts-grid">
          {thirdsub.map((item) => (
            <div key={item.id} className="ts-card">
              {item.iconurl && (
                <img src={item.iconurl} alt={item.subheading} className="ts-icon" />
              )}
              <h3 className="ts-card-title">{item.subheading}</h3>
              <p className="ts-card-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default ThirdSection;
